export const clearAppCache = () => {
  try {
    const specificKeys = [
      import.meta.env.VITE_LOCALE_TOKEN_NAME,
      'lastTimer',
      'card-app-auth',
    ];

    specificKeys.forEach((key) => {
      if (key) localStorage.removeItem(key);
    });

    const localStorageKeysToRemove = Object.keys(localStorage).filter(
      (key) =>
        key.includes('wagmi') ||
        key.includes('magic') ||
        key.includes('wallet') ||
        key.includes('auth') ||
        key.includes('card-app') ||
        key.includes('pimlico') ||
        key.includes('smart-account') ||
        key.includes('viem') ||
        key.includes('permissionless'),
    );
    localStorageKeysToRemove.forEach((key) => localStorage.removeItem(key));

    const sessionStorageKeysToRemove = Object.keys(sessionStorage).filter(
      (key) =>
        key.includes('wagmi') ||
        key.includes('magic') ||
        key.includes('wallet') ||
        key.includes('auth') ||
        key.includes('card-app') ||
        key.includes('pimlico') ||
        key.includes('smart-account') ||
        key.includes('viem') ||
        key.includes('permissionless'),
    );
    sessionStorageKeysToRemove.forEach((key) => sessionStorage.removeItem(key));

    console.log('App storage cleared successfully');
  } catch (error) {
    console.error('Error clearing app storage:', error);
  }
};
